/**
 * Product Image Carousel
 * Gestion du carrousel d'images produit avec miniatures
 */
class ProductCarousel {
  constructor() {
    this.currentImageIndex = 0;
    this.mainImage = null;
    this.thumbnails = [];
    this.init();
  }

  init() {
    this.setup();
  }

  setup() {
    // Sélectionner l'image principale et les miniatures
    this.mainImage =
      document.querySelector(".product-carousel__main-image img") ||
      document.querySelector(".product-carousel__main-image .image img");
    this.thumbnails = document.querySelectorAll(".product-carousel__thumbnail");

    // Vérifier que les éléments existent
    if (!this.mainImage || this.thumbnails.length === 0) {
      return;
    }

    this.bindEvents();
    this.setActiveThumbnail(0);
  }

  bindEvents() {
    this.thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener("click", (e) => {
        e.preventDefault();
        this.changeImage(index);
      });

      // Accessibilité clavier
      thumbnail.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          this.changeImage(index);
        }
      });
    });

    // Navigation clavier sur l'image principale
    if (this.mainImage) {
      this.mainImage.addEventListener("keydown", (e) => {
        if (e.key === "ArrowLeft") {
          e.preventDefault();
          this.previousImage();
        } else if (e.key === "ArrowRight") {
          e.preventDefault();
          this.nextImage();
        }
      });
    }
  }

  changeImage(index) {
    if (index < 0 || index >= this.thumbnails.length) {
      return;
    }
    if (index === this.currentImageIndex) {
      return;
    }

    const thumbnail = this.thumbnails[index];
    let newImageSrc = thumbnail.getAttribute("data-full-image");
    const thumbnailImg = thumbnail.querySelector("img");
    const newImageAlt = thumbnailImg?.alt || "";

    if (!newImageSrc) {
      return;
    }

    const mainImageContainer = document.querySelector(
      ".product-carousel__main-image"
    );
    if (!mainImageContainer) {
      return;
    }

    const direction = index > this.currentImageIndex ? 1 : -1;
    const DURATION = 300;
    const easing = "cubic-bezier(0.25, 0.46, 0.45, 0.94)";

    // Créer la nouvelle image (cachée à droite ou à gauche)
    const newSlide = document.createElement("div");
    newSlide.innerHTML = `
      <div class="image product-carousel__main-img">
        <img src="${newImageSrc}" alt="${newImageAlt}" loading="eager">
      </div>
    `;
    Object.assign(newSlide.style, {
      position: "absolute",
      inset: "0",
      transform: `translateX(${direction * 100}%)`,
      transition: `transform ${DURATION}ms ${easing}`,
    });

    // L'ancien contenu doit aussi être positionnable
    const oldContent = mainImageContainer.firstElementChild;
    if (oldContent) {
      Object.assign(oldContent.style, {
        position: "relative",
        transition: `transform ${DURATION}ms ${easing}`,
      });
    }

    mainImageContainer.style.overflow = "hidden";
    mainImageContainer.style.position = "relative";
    mainImageContainer.appendChild(newSlide);

    // Forcer un reflow pour déclencher la transition
    newSlide.getBoundingClientRect();

    // Lancer l'animation
    newSlide.style.transform = "translateX(0)";
    if (oldContent) {
      oldContent.style.transform = `translateX(${-direction * 100}%)`;
    }

    setTimeout(() => {
      mainImageContainer.innerHTML = newSlide.innerHTML;
      mainImageContainer.style.overflow = "";
      this.mainImage = mainImageContainer.querySelector("img");
    }, DURATION);

    this.currentImageIndex = index;
    this.setActiveThumbnail(index);
  }

  setActiveThumbnail(index) {
    // Retirer la classe active de toutes les miniatures
    this.thumbnails.forEach((thumb) => {
      thumb.classList.remove("product-carousel__thumbnail--active");
      thumb.setAttribute("aria-selected", "false");
    });

    // Ajouter la classe active à la miniature sélectionnée
    if (this.thumbnails[index]) {
      this.thumbnails[index].classList.add(
        "product-carousel__thumbnail--active"
      );
      this.thumbnails[index].setAttribute("aria-selected", "true");
    }
  }

  nextImage() {
    const nextIndex = (this.currentImageIndex + 1) % this.thumbnails.length;
    this.changeImage(nextIndex);
  }

  previousImage() {
    const prevIndex =
      this.currentImageIndex === 0
        ? this.thumbnails.length - 1
        : this.currentImageIndex - 1;
    this.changeImage(prevIndex);
  }
}

// Initialiser le carrousel - Attendre que le document soit complètement chargé
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    new ProductCarousel();
  });
} else {
  // Le DOM est déjà chargé
  new ProductCarousel();
}
